import { apiGet } from '../../../adapters/api-client/api';

/**
 * S5.7 — the public teacher profile a parent reads before deciding.
 * `teacherId` is the identifier courses carry, so links compose from search
 * results and course detail without a second lookup.
 */

export interface PublicTeacherCourse {
  courseId: string;
  title: string;
  subject: string;
  price: number;
  /** What the price is denominated in. */
  currency: string;
  duration: number;
  offerMode: string;
  deliveryFormat: string;
}

export interface PublicTeacherProfile {
  teacherId: string;
  firstName: string;
  lastName: string;
  bio: string;
  languages: string[];
  yearsExperience?: number;
  certifications: string[];
  methodology: string;
  subjects: string[];
  levels: string[];
  /** DEC-S2-S05-02: derived from current eligibility, never a stored flag. */
  verified: boolean;
  /**
   * Null when the server could not read the catalog — which is not the same as
   * the teacher having nothing published, and must not be shown as if it were
   * (PRT-BR-P05-20). No trust score: D-P05-02 keeps it off every teacher
   * surface.
   */
  publishedCourses: PublicTeacherCourse[] | null;
}

export function getTeacherProfile(teacherId: string): Promise<PublicTeacherProfile> {
  // Public, like the catalog it is reached from (PRT-BR-P01-01): the endpoint
  // is @Public() and a signed-out family has no token to send.
  return apiGet(`/api/v1/teachers/${teacherId}`, false);
}
